<template>
    <div class="rhythmClass">
        <el-col :span="24" class="zhiAudio" align="left" v-if="heart.questionDto.detailInfo.audioUrl">
            <audio-style 
                style="width:180px;float:left"
                ref="audioRef"
                @startPlaying="startPlaying"
                @endPlaying="endPlaying"
                @getPlays="getPlays"
                :styleText="'请点击播放'"
                :audioUrl="heart.questionDto.detailInfo.audioUrl"
                class="audioCom"
            ></audio-style>
            <div class="playNum" v-if="heart.audioPlayTime!=-1">
                <div class="playNumIng"><img src="./../../../static/images/play.png" alt="" srcset=""></div>
                {{`X${plays}`}}
            </div>
        </el-col>
        <el-col :span="24" class="explainText" v-if="heart.questionDto.detailInfo.audioUrl">
            点击音频部分播放
        </el-col>
        <div class="quImg" v-if="heart.questionDto.detailInfo.questionWriteUrl">
            <img :src="heart.questionDto.detailInfo.questionWriteUrl" v-viewer alt="" srcset="">
        </div>
        <el-col :span="24" class="imgStyle" align="left" :style="{top:(heart.questionDto.detailInfo.questionWriteUrl? '40%':'45px'),paddingTop:(heart.questionDto.detailInfo.questionWriteUrl? '18px':'51px')}">
            <div class="playTheDrumsLeft" v-if="!updataImgUrl"></div>
            <div class="haveGotOnTheBus" v-else>
                <img :src="updataImgUrl" alt="图片">
            </div>
            <div class="playTheDrumsRight" :style="{width:updataImgUrl? '20%':'',marginLeft:updataImgUrl? '7%':''}">
                <div class="operBox" @click="submitNumLimit()">
                    <updata-img ref="upImg"
                        :style="{pointerEvents:(!(submitNum>0||submitNum==-1)? 'none':'auto')}"
                        :styleEd="'\
                            width: 100%;\
                            font-size: 17px;\
                            background-color: rgb(0, 204, 106);\
                            color: #fff;border-radius: 5px;\
                            border: 3px solid rgb(207, 255, 232);'"
                            @upImgUrl="upImgUrl($event)"
                        :text="yangText">
                    </updata-img>
                    <p class="operation-num">剩余上传次数：{{submitNum==-1? '不限次':submitNum}}</p>
                    <p class="operation-topTag" v-if="!updataImgUrl">请在纸上记录播放内容,并拍照上传</p>
                    <div class="operation-tag" v-if="!updataImgUrl">注：请上传jpge、png格式文件，文件大小限制在20MB内</div>
                </div>
            </div>
        </el-col>
    </div>
</template>
<script>
import audioStyle from '../../components/audioStyle'
import updataImg from '../../components/updataImg'
import utils from '../../lib/util'
import wsMethod from '../../lib/socketMethod'
    export default {
        name:"listenWrite",
        props: {
            sonData: Object,
            allAnswer:Object,
        },
        data() {
            return {
                heart:{
                    questionDto:{
                        detailInfo:{}
                    }
                },
                rhythmBeatVal:[],
                timeHer:'',
                advancedRadio:'',
                plays:0,
                submitNum:0,
                questionImgUrl:'',
                updataImgUrl:'',
                yangText:'上传图片',
                answerType:null,
            }
        },
        components:{
            audioStyle,
            updataImg
        },
        watch: {
            'updataImgUrl':function(now,old){
                if(now&&this.answerType)this.answerType = null
                this.$emit('storeLocally')
            },
            'plays':function(now,old){
                this.$emit('storeLocally')
            },
            'answerType':function(now,old){
                this.$emit('storeLocally')
            },
            'submitNum':function(now,old){
                this.$emit('storeLocally')
            }
        },
        computed:{},
        created(){},
        mounted(){
            this.heart = this.sonData
            this.$nextTick(function(){
                this.rhythmBeatVal = []
                this.plays = utils.mottoClone(this.heart.audioPlayTime)
                this.submitNum = utils.mottoClone(this.heart.submitNum)
                if(this.allAnswer){
                    this.updataImgUrl = this.allAnswer.obj.writeImgUrl
                    this.answerType = this.allAnswer.obj.answerType
                    this.plays = this.allAnswer.playss
                    this.submitNum = this.allAnswer.submitNum
                    this.yangText = ' 重  拍 '
                }
            })
        },
        methods:{
            getPlays(){
                //限定播放次数
                this.$refs.audioRef.fatherPlay(this.plays,this.heart.audioPlayTime)
            },
            startPlaying(){
                
            },
            endPlaying(){
                if(this.plays<=0) this.plays=0
                else this.plays--;
            },
            upImgUrl(url){
                let plays = this.submitNum
                let nPlays = this.heart.submitNum
                if(plays>0||nPlays==-1){
                    this.updataImgUrl = url
                    this.$refs.upImg.url = '',
                    this.$refs.upImg.fileList = [],
                    this.yangText = ' 重  拍 '

                    if(this.submitNum<=0) this.submitNum==-1? this.submitNum=-1:this.submitNum=0
                    else this.submitNum--;

                    this.$nextTick(()=>{
                        wsMethod.wsSend210(this.heart.bId,this.heart.questionId,{
                            allData:this.$parent.allData,
                            uuid1:this.$parent.uuid1,
                            firstStartDateVal:this.$parent.firstStartDateVal,
                        })
                    })
                }else{
                    this.$message({showClose: true,message: `只能上传${nPlays}次`})
                }
            },
            yesNotProblem(){
                this.questionImgUrl = this.updataImgUrl
                if(this.updataImgUrl) return true
                return false
            },
            endAudio(){
                if(!this.heart.questionDto.detailInfo.audioUrl) return
                if(!this.$refs.audioRef.judgePaying()){
                    this.endPlaying()
                }
                this.$refs.audioRef.endAudio()
            },
            submitNumLimit(){
                let plays = this.submitNum
                let nPlays = this.heart.submitNum
                if(plays>0||nPlays==-1){}else{
                    this.$message({showClose: true,message: `只能上传${nPlays}次`})
                }
            },
            changeAnswerType(val){
                this.answerType = val.answerType
            }
        }
    }
</script>
<style scoped lang="less">
    .rhythmClass{
        height: 100%;
        width: 100%;
        position: relative;
        .zhiAudio{
            height: 33px;
            width: 100%;
            box-sizing: border-box;
            padding-left: 16px;
            .playNum{
                float: left;
                display: inline-block;
                height: 33px;
                width: 100px;
                .playNumIng{
                    display: inline-block;
                    img{
                        margin: 5px 0 0 15px;
                        vertical-align: text-bottom;
                    }
                }
            }
        }
        .explainText{
            box-sizing: border-box;
            padding:5px 0 0 16px;
            text-align: left;
            font-size: 12px;
            color: #A0A1A0;
        }
        .quImg{
            position: absolute;
            top: 0;
            left: 0;
            box-sizing: border-box;
            padding-top: 55px;
            width: 100%;
            height: 40%;
            display: inline-block;
            pointer-events: none;
            img{
                display: table-cell;
                vertical-align: middle;
                align-items: center;
                max-height: 100%;
                max-width: 100%;
            }
        }
        .imgStyle{
            position: absolute;
            top: 40%;
            left: 0;
            bottom: 0;
            width: 100%;
            box-sizing: border-box;
            padding: 25px 18px;
            background-image: url('../../../static/images/back-bg.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            .playTheDrumsLeft{
                width: 38%;
                height: 100%;
                float: left;
                position: relative;
                background-image: url('../../../static/images/takingPictures.png');
                background-size: 39%;
                background-position: 95% 50%;
                background-repeat: no-repeat;
            }
            .haveGotOnTheBus{
                width: 60%;
                height: 90%;
                margin-top: 2.5%;
                float: left;
                margin-left: 7%;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: scale-down;
                }
            }
            .playTheDrumsRight{
                width: 40%;
                height: 100%;
                float: left;
                box-sizing: border-box;
                padding-left: 15px;
                position: relative;
                display: table;
                .operBox{
                    width: 100%;
                    display: table-cell;
                    vertical-align: middle;
                    .operationGo{
                        width: 100%;
                        font-size: 17px;
                        background-color: rgb(0, 204, 106);
                        color: #fff;
                        border-radius: 5px;
                        border: 3px solid rgb(207, 255, 232);
                    }
                    .operation-num{
                        font-size: 13px;
                        text-align: center;
                    }
                    .operation-topTag{
                        width: 100%;
                        text-align: center;
                        font-size: 1rem;
                        margin-top: 5px;
                        color: #000;
                    }
                    .operation-tag{
                        // height: 20%;
                        width: 100%;
                        box-sizing: border-box;
                        padding: 9px 20px;
                        text-align: center;
                        background-color: #F4F9FE;
                        color: #1D8EFE;
                        font-size: 0.8rem;
                        margin-top: 7px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/exam/listenWrite.vue